import * as types from "../types.js";

const init = {
  name: "",
  order: [],
  comments: "",
  menu: {},
  location: "BRITANNIA",
  meetingType: "",
  snackbarAlertOpen: false,
  menuAlertOpen: false,
};
const reducer = (state = init, action) => {
  switch (action.type) {
    //name
    case types.UPDATE_NAME:
      return { ...state, name: action.payload };
    //add drink
    case types.ADD_DRINK_TO_ORDER:
      return { ...state, order: [...state.order, action.payload] };
    //remove drink (long form)
    case types.REMOVE_DRINK_FROM_ORDER:
      const newState = { ...state };
      let newOrder = [...newState.order];
      newOrder.splice(action.payload, 1);
      newState.order = newOrder;
      return newState;
    //clear order (long form)
    case types.CLEAR_ORDER:
      return { ...state, order: [], comments: "" };
    //comments
    case types.UPDATE_COMMENTS:
      return { ...state, comments: action.payload };
    //clear comments
    case types.CLEAR_COMMENTS:
      return { ...state, comments: "" };
    //menu from server API
    case types.UPDATE_MENU:
      return { ...state, menu: [...state.menu, action.payload] };
    //meeting location
    case types.CLIENT_MEETING_LOCATION:
      return { ...state, location: action.payload };
    //meeting type
    case types.CLIENT_MEETING_TYPE:
      return { ...state, meetingType: action.payload };
    //snackbar alert
    case types.SET_SNACKBAR_ALERT:
      return { ...state, snackbarAlertOpen: action.payload };
    //fixed bottom navigation
    case types.SET_MENU_ALERT:
      return { ...state, menuAlertOpen: action.payload };
    //Meeting date
    case types.CLIENT_MEETING_DATE:
      return { ...state, meetingDate: action.payload };
    //default
    default:
      return state;
  }
};
export default reducer;
